import { useContext } from 'react';
import { CardHeader, CardContent, TextField as MuiTextField, Grid, Button, CircularProgress, Typography, MenuItem } from '@material-ui/core';
import { applicationContext } from 'helpers/services';
import { Form, Formik, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { customerContext } from './CustomerContext';
import { FilterContainer } from 'components';


let Customer = () => {
    let appService = useContext(applicationContext);
    let service = useContext(customerContext);


    return (
        <>
            <CardHeader
                disableTypography
                title={<Typography variant="h4">Customer information</Typography>}
            />
            <CardContent>
                <FilterContainer onSubmit={() => service.searchUser()}>
                    <Grid item xs>
                        <MuiTextField
                            label="Email"
                            variant="outlined"
                            type="email"
                            value={service.user.email}
                            onChange={(e: any) => service.updateUser({
                                ...service.user,
                                email: e.target.value
                            })}
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            type="submit"
                            color="secondary"
                            variant="contained"
                            disabled={service.isSearching}
                        >
                            {service.isSearching && <CircularProgress size={20} />}&nbsp;Find user
                        </Button>
                    </Grid>
                </FilterContainer>

                {service.isSearchDone === true &&
                    <Formik
                        enableReinitialize={true}
                        validationSchema={service.userSchema}
                        initialValues={service.user}
                        onSubmit={(values) => service.createUser(values)}
                    >
                        <Form>
                            <Grid container>
                                {service.isNew === true &&
                                    <>
                                        <Grid item xs={12}>
                                            <Typography>User not found, please provide some basic information</Typography>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name="firstName"
                                                label="First Name"
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name="lastName"
                                                label="Last Name"
                                                variant="outlined"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                label="Country"
                                                variant="outlined"
                                                select
                                                name="countryCode"
                                            >
                                                {appService.countries.map(country =>
                                                    <MenuItem key={country.key} value={country.key}>{country.value}</MenuItem>
                                                )}
                                            </Field>
                                        </Grid>

                                        <Grid item>
                                            <Button
                                                type="submit"
                                                color="secondary"
                                                variant="contained"
                                                disabled={service.isSaving}
                                            >
                                                {service.isSaving && <CircularProgress size={20} />}&nbsp;Create user
                                            </Button>
                                        </Grid>
                                    </>
                                }
                                {service.isNew === false &&
                                    <Grid item xs>
                                        <Typography>
                                            {service.user.firstName && <>{service.user.firstName}&nbsp;{service.user.lastName}&nbsp;&#45;&nbsp;</>}
                                            Can login with&nbsp;{service.userProviders}
                                        </Typography>
                                    </Grid>
                                }
                            </Grid>
                        </Form>
                    </Formik>
                }
            </CardContent>
        </>
    )
}

export default Customer;